import React, {FC, useRef, useEffect, useLayoutEffect} from "react";
import {
  BodyTitle,
  Row,
  PropsContainer,
  ListWrapper,
  StyledIconMore,
  BodyNameLink,
  CardFieldLabel,
} from "./styles";
import CheckBox from "../checkbox";
import { icons } from "../../icons";
import StyledIcon from "../styled-icon";
import DropOptions  from '../drop-options';
// import DropOptions from "../header/components/drop-options";
import NewNotification from './new.svg'
import Button from "../button";
import { ChevronIc } from "../header/styles";
import { usePermissionActionFilter } from '../../permissions';
import { useTranslation } from "react-i18next";


export type RowItem = {
  rowKey?: any,
  item: any,
  darkBack:boolean,
  first:boolean,
  more:boolean,
  setHover:any,
  index:any,
  hover:boolean,
  hideCheckbox?:boolean,
  navigateTo?:string,
  withBack?:boolean,
  eye?:boolean,
  isNotifications?:boolean,
  generated?:boolean,
  isRead?:boolean,
  settings?:any,
  itemToEdit?:any,
  limitedItems?:any,
  allChecked?:any,
  checked?:any,
  setChecked?:any,
  hasDroppedRow?:boolean,
  options?:any,
  drop?:any,
  setDrop?:any,
  setOptions?:any,
  dropNodes?:any,
  setDropNodes?:any,
  testId?:string,
  columnTitle?:string,
  filterSettings?:(row:any, options:any[]) => any[],
  layout?:'table' | 'card',
  cardRole?:'primary' | 'status' | 'field' | 'action' | 'utility',
  fullWidth?:boolean,
}

const TableRowItem:FC<RowItem> = (props) => {
  // const [options, setOptions] = useState<boolean>(false)
  // const [drop, setDrop] = useState<boolean>(false)

  const optionsRef:any = useRef()
  const dropsRef:any = useRef()
  const {
    item,
    darkBack,
    first,
    more,
    setHover,
    index,
    hover,
    hideCheckbox,
    navigateTo,
    withBack,
    eye,
    isNotifications,
    generated,
    isRead,
    settings,
    itemToEdit,
    limitedItems,
    checked,
    setChecked,
    rowKey,
    hasDroppedRow,
    options,
    drop,
    setDrop,
    setOptions,
    dropNodes,
    setDropNodes,
    testId,
    columnTitle,
    filterSettings,
    layout='table',
    cardRole,
    fullWidth,
  } = props 
  const [t] = useTranslation()
  const isCard = layout === 'card'
  useEffect(() => {
    if (!options) {
      return
    }

    const handleClickOutside = (event:any) => {
      if (optionsRef && !optionsRef?.current?.contains(event.target) && !dropsRef?.current?.contains(event.target)){
        setOptions(false)
      }
    }

		document.addEventListener('click', handleClickOutside, true);
		return () => {
      document.removeEventListener('click', handleClickOutside, true);
		};
  },[options, setOptions]);
  const handleChangeDropped = () => {
    setDrop(!drop)
  }
  const selectRef:any = useRef()
  useLayoutEffect(() => {
    if (!options) {
      return;
    }

    const checkSelectContainerPosition = () => {
      const windowHeight = window.innerHeight;
      const selectContainer = dropsRef.current;
      const containerPosition = selectContainer?.getBoundingClientRect();
      if(containerPosition === undefined){
        return
      }
      const optionsHeight = optionsRef.current?.scrollHeight || optionsRef.current?.offsetHeight || 0;
      if (containerPosition?.bottom && (optionsHeight + containerPosition.bottom) > windowHeight) {
        optionsRef.current?.style.setProperty('top', 'auto');
        optionsRef.current?.style.setProperty('bottom', isCard ? '44px' : `${selectRef.current?.getBoundingClientRect()?.height - 15}px`);
        optionsRef.current?.style.setProperty('transform-origin', 'bottom right');
      } else {
        optionsRef.current?.style.setProperty('bottom', 'auto');
        optionsRef.current?.style.setProperty('top', isCard ? '44px' : 'auto');
        optionsRef.current?.style.setProperty('transform-origin', 'top right');
      }
    };

    checkSelectContainerPosition();
    const animationFrame = requestAnimationFrame(checkSelectContainerPosition);
    const handleScroll = () => {
      checkSelectContainerPosition();
    };
    window.addEventListener('scroll', handleScroll, true);
    window.addEventListener('resize', handleScroll);
    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', handleScroll);
    };
  }, [isCard, options]);
  const baseOptions = itemToEdit?.dropOptions?.length > 0 ? itemToEdit?.dropOptions : settings || []
  const resolvedOptions = filterSettings ? filterSettings(itemToEdit, baseOptions) : baseOptions
  const resolvedLimitedItems = filterSettings ? filterSettings(itemToEdit, limitedItems || []) : limitedItems
  const filterInput = {
    itemAllowedActions: itemToEdit?.allowed_actions,
    extraGuards: {
      invitationAccepted: !itemToEdit?.invitation,
      invitationPending: Boolean(itemToEdit?.invitation),
    },
  }
  const visibleOptions = usePermissionActionFilter(resolvedOptions, filterInput)
  const visibleLimitedItems = usePermissionActionFilter(resolvedLimitedItems || [], filterInput)
  const hasVisibleContextMenu = itemToEdit?.invitation ? visibleLimitedItems.length > 0 : visibleOptions.length > 0
  return (
    <Row
      as={isCard ? 'div' : undefined}
      data-test={testId}
      data-label={columnTitle}
      $layout={layout}
      $cardRole={cardRole}
      $fullWidth={fullWidth}
      hover={hover}
      ref={selectRef}
      hasDisplayTask={itemToEdit?.display_task !== null && itemToEdit?.display_task !== undefined}
      onMouseEnter={() => {
        setHover(index)
      }}
      onMouseLeave={() => {
        setHover(null)
      }}
      //@ts-ignore
      onClick={hasDroppedRow && itemToEdit?.hasHistory && !isCard ? handleChangeDropped : undefined}
      isProps={more || eye}
      back={darkBack}
      key={rowKey}
    >
      {isCard && cardRole === 'field' && columnTitle ?
        <CardFieldLabel>{columnTitle}</CardFieldLabel>
      : null}
      <div style={
        more || eye ? 
          {display:'flex', alignItems:isCard ? 'center' : 'flex-start', width:'100%', height:'100%', justifyContent:'flex-end'}
        :
          {display:'flex', alignItems:'center', height:'100%', width:'100%', justifyContent:'flex-start'}
        }
      >
        {hasDroppedRow && first && itemToEdit.hasHistory && !isCard && 
          <Button
            onClick={handleChangeDropped}
            variant='icon'
            size='small'
            // disabled
            active={drop}
            customStyles={
              { width: '22px', height: "22px", margin: '3px 10px 0px 0px' }
            }
          >
            <ChevronIc active={drop} src={icons.Chevron} />
          </Button>
        }
        {first && !hideCheckbox && !itemToEdit?.hideCheckbox && typeof setChecked === 'function' ?
          <CheckBox
            customStyles={isCard ? {
              width:'44px',
              height:'44px',
              justifyContent:'center',
              margin:'-12px -10px -12px -12px',
              '& input': {margin: 0},
            } : {marginTop:'3px'}}
            value={checked && checked.find((check:any) => check?.id === itemToEdit.id)}
            title=''
            ariaLabel={t('SELECT_ROW')}
            onChange={() => setChecked(itemToEdit)}
          />
        : null}
        {first && navigateTo ? 
          <BodyNameLink
            isRead={isRead}
            isNotifications={isNotifications && !isRead}
            //@ts-ignore
            to={navigateTo}
            // href={navigateTo}
            onClick={() => {
              if(itemToEdit?.onClick){
                itemToEdit.onClick()
              }
            }}
          >
            {isNotifications ? !isRead ? <img alt="" src={NewNotification}/> : null : null}
            {Array.isArray(item) ?
              <ListWrapper>{item.map((text:string) => text)}</ListWrapper>
            : 
              item
            }
          </BodyNameLink>
        :
          <>
            {(more || eye) ? item ? item :
              itemToEdit?.hideProps || (!eye && !hasVisibleContextMenu) ? null :
              <div style={{display:'flex'}} ref={dropsRef}>
                {eye ?
                  <Button
                    onClick={itemToEdit?.onPressEye}
                    variant='icon'
                    size='small'
                    ariaLabel={isRead ? t('MARK_AS_UNREAD') : t('MARK_AS_READ')}
                    customStyles={isCard ? {width:'44px', height:'44px', background:'transparent'} : {width:'26px', height:'20px', background:'transparent'}}
                  >
                    <StyledIcon
                      src={isRead ? icons.ShowPassword : icons.HidePassword}
                    />
                  </Button>
                :
                  <Button
                    onClick={() => setOptions((options:boolean) => !options)}
                    variant='icon'
                    active={options}
                    isProps={true}
                    size='small'
                    ariaLabel={t('ROW_ACTIONS')}
                    customStyles={isCard ? {width:'44px', height:'44px', background:'transparent'} : {width:'26px', height:'20px', background:'transparent'}}
                  >
                    <StyledIconMore src={icons.More}/>
                  </Button>
                  // <StyledIcon
                  // onClick={() => setOptions((options:boolean) => !options)} src={icons.More}/>
                }
              </div>
            : 
              Array.isArray(item) ? 
                <ListWrapper withBack={withBack}>
                  {item.map((text:string) => (
                    <BodyTitle withBack={withBack}>{text}</BodyTitle>
                  ))}
                </ListWrapper> 
              :
                <BodyTitle
                  style={first && itemToEdit?.customBodyRow ? {paddingRight:'10px'} : {}}
                  isRead={isRead} 
                  isNotifications={isNotifications && !generated}
                >
                  {item}
                </BodyTitle>
            }
          </>
        }
        {first && itemToEdit.customBodyRow && !isCard && 
          <Button
            onClick={itemToEdit?.id === dropNodes ? () => {
              setDropNodes(false)
            } : () => {
              setDropNodes(itemToEdit.id)
            }}
            variant='icon'
            size='small'
            // disabled
            active={itemToEdit?.id === dropNodes}
            customStyles={{ width: '22px', height: "22px", margin: '3px 10px 0px 0px' }}
          >
            <ChevronIc active={itemToEdit?.id === dropNodes} src={icons.Chevron} />
          </Button>
        }
      </div>
      {drop && first && itemToEdit.hasHistory && !isCard ? 
        <div style={{display:'flex', maxWidth:'250px'}}>
          {itemToEdit.customBody}
        </div>
      : null}
      {more && hasVisibleContextMenu && options ?
        <PropsContainer ref={optionsRef} active={options} $card={isCard}>
          <DropOptions
            options={resolvedOptions}
            itemToEdit={itemToEdit}
            limitedItems={resolvedLimitedItems}
            handleClose={() => setOptions(false)}
          />
        </PropsContainer>
      : null}
    </Row>
  )
}

export default TableRowItem
